<script setup lang="ts">
interface ExportItem {
  command: string,
  label: string,
}

interface Props {
  data: ExportItem[]
  disabled?: boolean,
}
interface  Emits {
  'exportData': [value: 'csv' | 'xlsx'],
}

//#region props
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
});
//#endregion

//#region emits
const emit = defineEmits<Emits>();
//#endregion

//#region methods
function exportData(format: 'csv' | 'xlsx') {
  emit('exportData', format);
}
//#endregion
</script>

<template>
  <ElDropdown
    class="export-data"
    trigger="click"
    :disabled="disabled"
    placement="bottom"
    @command="exportData"
  >
    <UiButton
      class="export-data__button"
      :disabled="disabled"
      is-icon
      icon="long-arrow-down"
    />
    <template v-slot:dropdown>
      <ElDropdownMenu class="export-data__list">
        <ElDropdownItem
          v-for="(item, index) in data"
          :key="index"
          :command="item.command"
          class="export-data__item"
        >
          {{ item.label }}
        </ElDropdownItem>
      </ElDropdownMenu>
    </template>
  </ElDropdown>
</template>

<style lang="scss">
.export-data {
  &__list{
    padding: 8px 0;
  }
  &__item {
    &.el-dropdown-menu__item {
      font-size: 12px;
      height: 28px;
      color: var(--text-body);
      white-space: nowrap;
      padding: 0 8px;
      &:not(.is-disabled):focus{
        color: var(--text-body);
        background-color: #fff;
      }
      &:not(.is-disabled):hover {
        background-color: var(--background-brand-subtle);
        color: var(--text-body);
      }
    }
  }
}
</style>
